
export class FranchiseTenantInfo {
  tenantID: number;
  alias: string;
  isActive: boolean;
  name: string;
  franchiseLevelID: number;
};